import * as Yup from 'yup'

import { EMAIL_REGEX, LINK_REGEX, TIMEZONES } from '../../helpers/constants'
import { ZIP_CODE_CA_REGEX, ZIP_CODE_US_REGEX } from '@/constants/regex'

export const formValidation = {
  required: Yup.string().required('Required'),
  weeklyLimiter: Yup.number().min(1, 'Maximum 99.').max(99, 'Maximum 99.'),
  bookingWindow: Yup.number().min(1, 'Maximum 99.').max(365, 'Maximum 365.'),
  email: Yup.string().matches(EMAIL_REGEX, 'Email is empty or not valid.').required('Required'),
  password: Yup.string().required('Required'),
  password2: Yup.string()
    .oneOf([Yup.ref('password'), null], 'Passwords don’t match. Double-check and try again!')
    .required('Required'),
  phone: Yup.string().max(15, 'Maximum 15 digits.').required('Required'),
  phoneNotRequired: Yup.string().max(15, 'Maximum 15 digits.'),
  birth: Yup.date().required('Required'),
  terms: Yup.boolean().oneOf([true], 'Must Accept Liability Waiver'),
  link: Yup.string().matches(LINK_REGEX, 'Link format is not valid.'),
  requiredLink: Yup.string().matches(LINK_REGEX, 'Link format is not valid.').required('Required'),
  requiredImage: Yup.object({
    image: Yup.string().required('Image is required'),
  }),
  requiredCategory: Yup.array().min(1),
  discount: Yup.string()
    .test('len', 'Must be exactly 4 characters', (val) => {
      if (val) {
        return val.toString().length === 4
      }
    })
    .required('Required'),
  timezone: Yup.string()
    .oneOf([TIMEZONES.CT, TIMEZONES.ET, TIMEZONES.MT, TIMEZONES.PT, TIMEZONES.AZ])
    .required(),
  numberID: Yup.number().required('Required'),
  postalCode: (storedValue) =>
    Yup.string()
      .required('Zip code is required')
      .test('postal-code-format', null, function (value) {
        // Validation should only run if the value has changed from the stored value.
        // That way older buildings with legacy zip codes are not unnecessarily flagged as invalid.
        if (storedValue && value === storedValue) return true

        const isCA = this.parent.country === 'CA'
        const regex = isCA ? ZIP_CODE_CA_REGEX : ZIP_CODE_US_REGEX
        const message = isCA
          ? 'Must be a valid Canadian postal code (A1A 1A1)'
          : 'Must be a valid US ZIP (12345 or 12345-6789)'

        return (
          regex.test(value ?? '') ||
          this.createError({
            message,
          })
        )
      }),
}
